<script setup>
import { Link } from "@inertiajs/inertia-vue3";
import Navbar from "@/Components/Navbar.vue";
import Modal from "@/Components/Calendar/Modal.vue";
import SearchModal from "@/Components/Calendar/SlotSearchModal.vue";
import Button from "@/Components/Button.vue";
import InputError from "@/Components/InputError.vue";
import Select from "@/Components/Select.vue";
import Textarea from "@/Components/Textarea.vue";
import Label from "@/Components/Settings/Label.vue";
import Input from "@/Components/Settings/Input.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import VueTimepicker from "vue3-timepicker";

import { Head } from "@inertiajs/inertia-vue3";
import { ref, watch, computed } from "vue";

import PatientSearch from "@/Components/Calendar/PatientSearch.vue";
import SeriesTypeSlot from "@/Components/Calendar/SeriesTypeSlot.vue";

import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
import debounce from "lodash/debounce";

const props = defineProps({
  errors: Object,
  practitioners: Array,
  rooms: Array,
  interval: Number,
  groups: Array,
  date: String,
  time: String,
  behandler: String,
  earlist: String,
  latest: String,
  interval_values: Object,
  ignore: Boolean,
});

const patientData = ref({
  patient_number: null,
  firstname: "",
  lastname: "",
  birthday: "",
  email: "",
  tel: "",
  customPatient: false,
});

// const minDate = ref(new Date().toISOString().split("T")[0]);

const isLoading = ref(false);

const patientResults = ref([]);

const showSearchModal = ref(false);

const modalData = ref({
  show: false,
  isLast: false,
  type: "",
  message: "",
});

const patientNumber = ref("");

// all types/steps of choosen group
const steps = ref([]);

// group id -> model
const group = ref(null);
const groupName = ref("");

const activeStep = ref(-1);
const seriesData = ref([]);

const errors = ref({});

const currentData = ref({
  date: "",
  start: "10:00",
  duration: "",
  practitioner_id: "",
  room_id: "",
  minDate: null,
  is_parallel: false,
});

let print = false;

watch(
  patientNumber,
  debounce((val) => {
    //TODO: before debounce
    resetPatientData();
    checkPatientNumber();
  }, 500)
);

function changeGroup() {
  //console.log(group.value);

  groupName.value = props.groups.find((g) => g.id == group.value).name;

  axios
    .get("/types/by-group", {
      params: {
        group_id: group.value,
      },
    })
    .then((res) => {
      steps.value = res.data;
      // console.log("response hgroup selected", res);

      seriesData.value = [];

      for (let i = 0; i < res.data.length; i++) {
        seriesData.value.push({
          date: null,
          start: "10:00", //TODO: default time
          duration: res.data[i].type.duration,
          practitioner_id: "",
          room_id: "",
          description: null,
          equipment: res.data[i].type.materials,
          type_id: res.data[i].type_id,
          is_parallel: false,
        });
      }
    });
}

function resetPatientData() {
  patientData.value = {
    patient_number: null,
    firstname: "",
    lastname: "",
    birthday: "",
    email: "",
    tel: "",
    customPatient: false,
  };
}

function toggleCustomPatientInput() {
  //console.log("test");
  //console.log(patientData.value.customPatient);
  if (patientData.value.customPatient) {
    patientData.value.customPatient = false;
    patientData.value.patient_number = null;
  } else {
    resetPatientData();

    patientData.value.customPatient = true;
  }
}

function selectPatient(patient) {
  patientData.value = { ...patient, customPatient: false };
  patientData.value.birthday = patientData.value.birthday
    ? new Date(patientData.value.birthday).toISOString().substr(0, 10)
    : null;
}

function checkPatientNumber() {
  axios
    .get("/patients/search", {
      params: {
        patient_number: patientNumber.value,
      },
    })
    .then((response) => {
      //console.log("patient_response", response);
      if (response.data.length > 0) {
        patientResults.value = response.data;
      }
    })
    .catch((err) => {
      console.error("patient_err", err);
    });
}
/**
 * validate patient data on backend
 * @param {object} data
 */
async function validateStep0() {
  return new Promise((resolve, reject) => {
    axios
      .post(
        "/validateSeriesStep0",
        {
          ...patientData.value,
          group_id: group.value,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        //console.log("result validation step 0", res);
        resolve(true);
      })
      .catch((err) => {
        //console.log(err);
        errors.value = { ...err.response.data.errors };
        //console.log("error validation step 0", errors.value);
        resolve(false);
      });
  });
}
/**
 * validate appointment data on backend
 * @param {object} data
 * @returns {Promise<boolean>}
 */
async function validateApplicationSteps(
  ignore_warnings = false,
  isLast = false
) {
  let shouldIgnore = ignore_warnings || props.ignore;
  //console.log(shouldIgnore);
  return new Promise((resolve) => {
    axios
      .post(
        "/validateSeriesStep1",
        {
          ...currentData.value,
          group_id: group.value,
          step: activeStep.value,
          previous_date:
            activeStep.value > 0
              ? seriesData.value[activeStep.value - 1].date
              : null,
          ignore_warnings: shouldIgnore,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        //console.log("result validation application steps", res);
        currentData.value.is_parallel = res.data.is_parallel;
        resolve(true);
      })
      .catch((err) => {
        let errorObj = err.response.data;
        if (errorObj.showModal) {
          modalData.value.show = true;
          modalData.value.isLast = isLast;
          modalData.value.type = errorObj.type;
          modalData.value.message = errorObj.message;
        }
        errors.value = { ...err.response.data.errors };
        //console.log("error validation application steps", errors.value);
        if (err.response.data.isOverlapping) {
          alert("Fehler: Überschneidung von Terminen");
        }
        resolve(false);
      });
  });
}

async function proceed(ignore_warnings = false) {
  modalData.value.show = false;
  errors.value = {};
  //console.log("current step", activeStep.value, seriesData.value[activeStep.value]);
  if (activeStep.value === -1) {
    if (!(await validateStep0())) {
      return;
    }
  } else {
    if (!(await validateApplicationSteps(ignore_warnings, false))) {
      return;
    }
  }
  if (activeStep.value >= 0) {
    seriesData.value[activeStep.value] = currentData.value;
  }
  activeStep.value < steps.value.length - 1 && activeStep.value++;
  currentData.value = seriesData.value[activeStep.value];

  if (activeStep.value > 0) {
    let blocked_period = steps.value[activeStep.value - 1].follow_up;
    let newMinDate = addDays(
      seriesData.value[activeStep.value - 1].date,
      blocked_period
    );
    currentData.value.minDate = newMinDate.toISOString().split("T")[0];
  }
}

function stepBack() {
  activeStep.value > -1 && activeStep.value--;

  if (activeStep.value >= 0) {
    currentData.value = seriesData.value[activeStep.value];
  }
}

function addDays(date, days) {
  date = new Date(date);
  date.setDate(date.getDate() + days);
  return date;
}

function storeAndPrint() {
  print = true;
  storeAppointment();
}

function storeAndNoPrint() {
  print = false;
  storeAppointment();
}

async function storeAppointment(ignoreWarning = false) {
  isLoading.value = true;
  let shouldIgnore = ignoreWarning || props.ignore;
  if (activeStep.value === steps.value.length - 1) {
    if (!(await validateApplicationSteps(shouldIgnore, true))) {
      //console.log("back from validation of steps");
      isLoading.value = false;
      return;
    } else {
      isLoading.value = false;
      //console.log("validation of last step should be ok");
    }

    Inertia.post(
      "/appointments/appointmentSeries",
      {
        patient_data: patientData.value,
        group_id: group.value,
        series: seriesData.value,
        print: print,
      },
      {
        onFinish: (data) => {
          isLoading.value = false;
        },
        onError: (errors) => {
          //console.log("error final step", errors.value);
        },
      }
    );
  }
}

function chooseSlot(slot) {
  //console.log("slot", slot);
  showSearchModal.value = false;
  currentData.value.date = slot.date;
  currentData.value.start = slot.startString;
}

function getUserName(practitioner_id) {
  if (practitioner_id) {
    return props.practitioners.find((p) => p.id == practitioner_id).username;
  }
  return "";
}

function getRoomName(room_id) {
  if (room_id) {
    return props.rooms.find((r) => r.id == room_id).number;
  }
  return "";
}

function isPractitionerSelected(user_id, activeStep) {
  if (activeStep === -1) {
    return false;
  } else {
    if (steps.value[activeStep].practitioners.length == 1) {
      if (user_id === steps.value[activeStep].practitioners[0].id) {
        currentData.value.practitioner_id = user_id;
      }
    } else {
      return false;
    }
  }
}
</script>

<template>
  <div
    id="theme-wrapper"
    style="background-image: url('/storage/img/auth_bg.jpg')"
    class="bg-cover bg-no-repeat flex h-screen bg-oteoBlue-600"
    :class="'theme-' + $page.props.theme ?? 'spitta'"
  >
    <Navbar class="navbar-sub w-full" />

    <SearchModal
      v-if="showSearchModal"
      :practitioners="props.practitioners"
      :rooms="props.rooms"
      :practitioner_id="currentData.practitioner_id"
      :room_id="currentData.room_id"
      :duration="currentData.duration"
      :start="currentData.date"
      :end="currentData.date"
      :interval="props.interval"
      @close="showSearchModal = false"
      @chooseSlot="chooseSlot"
    ></SearchModal>

    <Modal :show="modalData.show" @close="modalData.show = false">
      <template #title> Fehler </template>
      <template #message>
        {{ modalData.message }}
      </template>
      <template #actions>
        <div class="" v-if="modalData.type === 'warning'">
          <div class="flex gap-5 justify-center mt-8">
            <Button
              class="mt-auto"
              @click="
                () => {
                  modalData.show = false;
                  showSearchModal = true;
                }
              "
              >Alternativer Termin</Button
            >

            <Button
              class="mt-auto"
              @click="
                () => {
                  modalData.isLast ? storeAppointment(true) : proceed(true);
                }
              "
              >Termin übernehmen</Button
            >
          </div>
        </div>

        <div class="" v-if="modalData.type === 'error'">
          <div class="flex gap-5 justify-center mt-8">
            <Button
              class="mt-auto"
              @click="
                () => {
                  modalData.show = false;
                  showSearchModal = true;
                }
              "
              >Alternativer Termin</Button
            >

            <Button class="mt-auto" @click="modalData.show = false"
              >Abbrechen</Button
            >
          </div>
        </div>
      </template>
    </Modal>

    <div class="bg-white w-full max-w-8xl m-auto rounded-xl relative">
      <header
        class="bg-gray-100 flex justify-between items-center px-12 py-8 rounded-tl-xl rounded-tr-xl relative"
      >
        <div class="flex">
          <Link href="/termin-erstellen">
            <h2 class="text-3xl font-light py-3 opacity-40 mr-8">
              Einzeltermin
            </h2>
          </Link>
          <Link href="/termin-erstellen?typ=serie">
            <h2 class="text-3xl py-3 font-semibold">Terminserie</h2>
          </Link>
        </div>

        <div
          class="w-16 overflow-hidden inline-block absolute left-[19.5rem] bottom-0"
        >
          <div
            class="h-8 w-11 bg-white rotate-45 transform origin-bottom-left"
          ></div>
        </div>

        <div class="flex relative">
          <!-- <slot name="controls" /> -->
          <HeaderLink class="mr-3" href="/" type="close">Abbrechen</HeaderLink>
          <HeaderButton
            class="mr-3"
            :class="{
              'bg-oteoBorder':
                activeStep !== steps.length - 1 || activeStep === -1,
            }"
            :disabled="
              activeStep !== steps.length - 1 || activeStep === -1
                ? true
                : false || isLoading
            "
            @click="storeAndPrint()"
            >Anlegen und Drucken</HeaderButton
          >
          <HeaderButton
            :class="{
              'bg-oteoBorder':
                activeStep !== steps.length - 1 || activeStep === -1,
            }"
            :disabled="
              activeStep !== steps.length - 1 || activeStep === -1
                ? true
                : false || isLoading
            "
            @click="storeAndNoPrint()"
            >Anlegen</HeaderButton
          >
        </div>
      </header>
      <div class="flex p-12 relative">
        <div class="md:flex-1">
          <div class="flex">
            <!-- #region 2.Left Serie Metadaten ab 1. Termin -->
            <div class="w-[30%] pr-16 pb-8" v-if="activeStep >= 0">
              <div class="text-s mb-2">Behandlungsgruppe:</div>
              <div class="text-2xl font-semibold">{{ groupName || "" }}</div>
              <div class="text-2xl font-light mb-10">
                Termin {{ activeStep + 1 }} / {{ steps.length || "" }}
              </div>

              <Label>Behandlungstyp</Label>

              <div class="bg-oteoInputBG text-oteoText rounded-md py-2 px-4">
                <span
                  class="w-3 h-3 rounded-full ml-auto mr-2 inline-block"
                  :style="`background-color:${steps[activeStep].type.color}`"
                ></span>
                {{ steps[activeStep].type.name }}
              </div>
            </div>
            <!-- #endregion -->

            <!-- #region 1.Left patient data -->

            <div class="w-[40%] pr-16 pb-8" v-if="activeStep === -1">
              <div class="">
                <Label for="patient_number" value="Patient suchen" />
                <div class="flex gap-4 mt-1 relative">
                  <PatientSearch
                    class="z-10"
                    :class="{ 'opacity-60': patientData.customPatient }"
                    :disabled="patientData.customPatient"
                    @selectPatient="selectPatient"
                  />

                  <div
                    class="absolute right-0 -bottom-5 text-xs font-semibold text-oteo-300 cursor-pointer"
                    @click="toggleCustomPatientInput"
                  >
                    <span v-if="!patientData.customPatient">
                      Oder manuell eingeben.
                    </span>
                    <span v-if="patientData.customPatient">
                      Patient/in suchen.
                    </span>
                  </div>
                </div>
                <InputError v-if="errors.patient_number" :absolute="true">
                  {{ errors.patient_number[0] }}
                </InputError>
              </div>
              <div
                class="mt-8"
                :class="{ 'opacity-60': !patientData.customPatient }"
              >
                <div class="">
                  <Label for="firstname" value="Vorname" />
                  <Input
                    :disabled="!patientData.customPatient"
                    id="firstname"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="patientData.firstname"
                    required
                    placeholder=""
                  />

                  <InputError v-if="errors.firstname" :absolute="true">
                    {{ errors.firstname[0] }}
                  </InputError>
                </div>

                <div class="mt-8">
                  <Label for="lastname" value="Nachname" />
                  <Input
                    :disabled="!patientData.customPatient"
                    id="lastname"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="patientData.lastname"
                    required
                    placeholder=""
                  />

                  <InputError v-if="errors.lastname" :absolute="true">
                    {{ errors.lastname[0] }}
                  </InputError>
                </div>

                <div class="mt-8">
                  <Label for="birthday" value="Geburtstag" />
                  <Input
                    :disabled="!patientData.customPatient"
                    id="birthday"
                    type="date"
                    class="mt-1 block w-full"
                    v-model="patientData.birthday"
                    placeholder=""
                  />

                  <InputError v-if="errors.birthday" :absolute="true">
                    {{ errors.birthday[0] }}
                  </InputError>
                </div>

                <div class="mt-8 flex gap-4">
                  <div class="w-full">
                    <Label for="tel">
                      Handy <span class="font-light">(für Terminservice)</span>
                    </Label>
                    <Input
                      :disabled="!patientData.customPatient"
                      id="tel"
                      type="tel"
                      class="mt-1 block w-full"
                      v-model="patientData.tel"
                      required
                      placeholder=""
                    />

                    <InputError v-if="errors.tel" :absolute="true">
                      {{ errors.tel[0] }}
                    </InputError>
                  </div>

                  <div class="w-full">
                    <Label for="email">
                      E-Mail <span class="font-light">(für Terminservice)</span>
                    </Label>
                    <Input
                      :disabled="!patientData.customPatient"
                      id="email"
                      type="email"
                      class="mt-1 block w-full"
                      v-model="patientData.email"
                      required
                      placeholder=""
                    />

                    <InputError v-if="errors.email" :absolute="true">
                      {{ errors.email[0] }}
                    </InputError>
                  </div>
                </div>
              </div>
            </div>
            <!-- #endregion -->
            <div
              class="px-16 pb-8 border-x border-gray-200"
              :class="{
                'w-[30%]': activeStep === -1,
                'w-[40%]': activeStep >= 0,
              }"
            >
              <!-- #region 1.Middle select group-->

              <div class="" v-if="activeStep === -1">
                <div class="">
                  <Label for="group_id" value="Behandlungsgruppe" />
                  <Select
                    id="group_id"
                    class="mt-1 block w-full"
                    v-model="group"
                    required
                    @change="changeGroup"
                  >
                    <option disabled value="">
                      Behandlungsgruppe auswählen
                    </option>

                    <option
                      v-for="group in groups"
                      :key="group.id"
                      :value="group.id"
                    >
                      {{ group.name }}
                    </option>
                  </Select>

                  <InputError v-if="errors.group_id" :absolute="true">
                    {{ errors.group_id[0] }}
                  </InputError>
                </div>
              </div>
              <!-- #endregion -->
              <!-- #region 2.Middle appointment data -->

              <div class="" v-if="activeStep >= 0">
                <div class="">
                  <Label for="date" value="Datum" />
                  <Input
                    id="date"
                    type="date"
                    :min="currentData.minDate"
                    class="mt-1 block w-full"
                    v-model="currentData.date"
                    required
                    placeholder=""
                    @change="errors.date = null"
                  />

                  <InputError v-if="errors.date" :absolute="true">
                    {{ errors.date[0] }}
                  </InputError>
                </div>

                <div class="mt-8">
                  <Label for="start" value="Uhrzeit" />
                  <!-- <Input
                    id="start"
                    type="time"
                    class="mt-1 block w-full"
                    v-model="currentData.start"
                    required
                    step="900"
                    min="10:00"
                    placeholder=""
                  /> -->

                  <VueTimepicker
                    class="timepicker-input"
                    v-model="currentData.start"
                    :key="activeStep"
                    :minute-interval="props.interval"
                    close-on-complete
                    fixed-dropdown-button
                  >
                    <template v-slot:dropdownButton>
                      <img :src="'/storage/icons/clock.png'" />
                    </template>
                  </VueTimepicker>

                  <InputError v-if="errors.start" :absolute="true">
                    {{ errors.start[0] }}
                  </InputError>
                </div>

                <div class="mt-8">
                  <Label for="duration" value="Dauer" />
                  <Select
                    id="duration"
                    class="mt-1 block w-full"
                    v-model="currentData.duration"
                    required
                  >
                    <option disabled value="">Dauer auswählen</option>

                    <!--<option v-for="n in 10" :key="n" :value="n">
                      {{ `${n} Einheiten` }} - {{ n * interval }} Min.
                    </option>-->
                    <option
                      v-for="(iv, n) in interval_values"
                      :key="n"
                      :value="n"
                    >
                      {{ `${n} Einheiten` }} - {{ iv }} Min.
                    </option>
                  </Select>

                  <InputError v-if="errors.duration" :absolute="true">
                    {{ errors.duration[0] }}
                  </InputError>
                </div>

                <div class="mt-8">
                  <Label for="practitioner_id" value="Behandler/in" />
                  <Select
                    id="practitioner_id"
                    class="mt-1 block w-full"
                    v-model="currentData.practitioner_id"
                    required
                  >
                    <option disabled value="">Behandler/in auswählen</option>

                    <option
                      v-for="user in practitioners"
                      :key="user.id"
                      :value="user.id"
                      :selected="isPractitionerSelected(user.id, activeStep)"
                    >
                      {{ user.fullname }}
                    </option>
                  </Select>

                  <InputError v-if="errors.practitioner_id" :absolute="true">
                    {{ errors.practitioner_id[0] }}
                  </InputError>
                </div>

                <div class="mt-8">
                  <Label for="room_id" value="Behandlungsraum" />
                  <Select
                    id="room_id"
                    class="mt-1 block w-full"
                    v-model="currentData.room_id"
                    required
                  >
                    <option disabled class="opacity-70" value="">
                      Behandlungsraum auswählen
                    </option>

                    <option
                      v-for="room in rooms"
                      :key="room.id"
                      :value="room.id"
                    >
                      {{ room.name }}
                    </option>
                  </Select>

                  <InputError v-if="errors.room_id" :absolute="true">
                    {{ errors.room_id[0] }}
                  </InputError>
                </div>
              </div>
              <!-- #endregion -->
            </div>

            <!-- #region 1.Right meta info + buttons -->

            <div class="w-[30%] pl-16 pb-8 flex flex-col">
              <div class="" v-if="activeStep >= 0">
                <div class="">
                  <Label for="equipment" value="Werkzeuge/Materialen" />
                  <Textarea
                    id="equipment"
                    class="mt-1 block w-full h-24 resize-none"
                    required
                    v-model="currentData.equipment"
                  />
                  <div
                    class="mt-2 text-red-600 text-sm"
                    v-if="errors.equipment"
                  >
                    {{ errors.equipment }}
                  </div>
                </div>

                <div class="mt-8">
                  <Label for="description" value="Anmerkungen" />
                  <Textarea
                    id="description"
                    class="mt-1 block w-full h-24 resize-none"
                    required
                    v-model="currentData.description"
                  />
                  <div
                    class="mt-2 text-red-600 text-sm"
                    v-if="errors.description"
                  >
                    {{ errors.description }}
                  </div>
                </div>
              </div>
              <div class="mt-auto">
                <HeaderButton
                  v-if="activeStep >= 0"
                  type="close"
                  class="w-full whitespace-nowrap"
                  @click="stepBack"
                >
                  Zurück</HeaderButton
                >
                <HeaderButton
                  v-if="
                    (steps && activeStep < steps.length - 1) ||
                    activeStep === -1
                  "
                  class="mt-4 w-full whitespace-nowrap"
                  @click="proceed(false)"
                >
                  {{ activeStep + 2 }}. Termin vereinbaren</HeaderButton
                >
              </div>
            </div>
            <!-- #endregion -->
          </div>
        </div>
      </div>

      <div
        v-if="steps.length > 0 && !showSearchModal"
        class="w-[95%] h-40 bg-white absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-3/4 rounded-2xl drop-shadow-2xl shadow-2xl flex overflow-x-scroll"
      >
        <div
          v-if="activeStep === -1"
          class="rounded-2xl absolute left-0 right-0 top-0 bottom-0 bg-gray-50 opacity-75"
        ></div>
        <SeriesTypeSlot
          v-for="(step, index) in steps"
          :stepData="step"
          :step="index"
          :activeStep="activeStep"
          :key="step.id"
          :maxSteps="steps.length"
          :date="seriesData[index].date"
          :start="seriesData[index].start"
          :duration="seriesData[index].duration * props.interval"
          :user_short="getUserName(seriesData[index].practitioner_id)"
          :room_short="getRoomName(seriesData[index].room_id)"
        />
      </div>
    </div>
  </div>
</template>
